import React from "react";
import styles from "./index.module.scss";
import { UserStatus } from "../members.mock-data";
import { IMemberData } from "../../../../../common/validations/members-access.validations";
import cn from "../../../../../Utils/class-names.utils";
import ResendIcon from "../../../../icons/resend.icon";
import ActionsMenu from "./actions-menu";
import { availableRolesList } from "../roles.mock-data";
import RoleBadges from "../../role-badges";

interface TableRowProps {
  userData: IMemberData;
  onAddRole: (userEmail: string, roleToAdd: string) => void;
  onRemoveRole: (userEmail: string, roleToRemove: string) => void;
  onResetPasswordClick: () => void;
  isDistributorView?: boolean;
}

const TableRow = ({ userData, onAddRole, onRemoveRole, onResetPasswordClick, isDistributorView = false }: TableRowProps) => {
  const userRoles = userData.role;

  const getStatusBadgeClass = () => {
    switch (userData.status) {
      case UserStatus.NotVerified:
        return styles.statusBadgeNotVerified;
      case UserStatus.Pending:
        return styles.statusBadgePending;
      case UserStatus.Disabled:
        return styles.statusBadgeDisabled;
      default:
        return "";
    }
  };

  const getRowClass = () => {
    return userData.status === UserStatus.Disabled ? styles.rowDisabled : "";
  };

  const handleAddRole = (roleValue: string) => {
    onAddRole(userData.email, roleValue);
  };

  const handleRemoveRole = (roleToRemove: string) => {
    onRemoveRole(userData.email, roleToRemove);
  };

  return (
    <div className={cn(styles.row, getRowClass())} role="row">
      <div className={`${styles.column} ${styles.columnName}`}>
        <div className={`${styles.cell} ${styles.cellName}`}>
          <div className={styles.nameText}>
            {userData.name}
          </div>

          <div className={styles.emailText}>
            {userData.email}
          </div>
        </div>
      </div>

      <div className={`${styles.column} ${styles.columnRole}`}>
        <div className={`${styles.cell} ${styles.cellRole}`}>
          <RoleBadges
            roles={userRoles}
            availableRoles={availableRolesList}
            onAddRole={handleAddRole}
            onRemoveRole={handleRemoveRole}
            disabled={userData.status === UserStatus.Disabled}
          />
        </div>
      </div>

      <div className={`${styles.column} ${styles.columnStatus}`}>
        <div className={`${styles.cell} ${styles.cellStatus}`}>
          <div className={styles.statusContainer}>
            <div className={`${styles.statusBadge} ${getStatusBadgeClass()}`}>
              <div className={styles.statusBadgeInner}>
                <div className={styles.statusText}>
                  {userData.status}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className={`${styles.column} ${styles.columnCreated}`}>
        <div className={`${styles.cell} ${styles.cellCreated}`}>
          <div className={styles.dateContainer}>
            <time
              className={styles.dateText}
              dateTime={userData.createdDate}
            >
              {userData.createdDate}
            </time>
          </div>
        </div>
      </div>

      <div className={`${styles.column} ${styles.columnLastLogin}`}>
        <div className={`${styles.cell} ${styles.cellLastLogin}`}>
          <div className={styles.dateContainer}>
            <time
              className={styles.dateText}
              dateTime={userData.lastLoginDate}
            >
              {userData.lastLoginDate}
            </time>
          </div>
        </div>
      </div>

      <div className={`${styles.column} ${styles.columnAuth}`}>
        <div className={`${styles.cell} ${styles.cellAuth}`}>
          {userData.status === UserStatus.Pending ? (
            <button
              className={cn(styles.resendSignupButton, "my-button")}
              type="button"
              aria-label="Resend signup"
            >
              <ResendIcon />
              <span>Resend Signup</span>
            </button>
          ) : (
            <div className={styles.authContainer}>
              {userData.authMethod.map((method, index) => (
                <div key={`${method}-${index}`} className={styles.authBadge}>
                  <div className={styles.authBadgeInner}>
                    <div className={styles.authText}>
                      {method}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>

      <div className={styles.columnActions}>
        <div className={`${styles.cell} ${styles.cellActions}`}>
          <ActionsMenu
            onResetPassword={() => {
              onResetPasswordClick();
            }}
            onResetMFA={() => {
            }}
            onActivateMFA={() => {
            }}
            onDisableAccount={() => {
            }}
            onEnableAccount={() => {
            }}
            onResendVerificationLink={() => {
            }}
            onDelete={() => {
            }}
            isDistributorView={isDistributorView}
            userStatus={userData.status}
          />
        </div>
      </div>
    </div>
  );
};

export default TableRow;
